<template>
  <view class="container" :class="{ 'popup-container': pageFrom === 'popup' }">
    <view class="select-place-header">
      <view class="back-item" v-if="pageFrom === 'page'" @click="handleBack">
        <text class="tripwisefont icon-icon_back back-icon"></text>
      </view>
      <view class="select-city-place">
        <view class="circle-icon" :style="{ backgroundColor: placeType == 1 ? '#057BFF' : '#f85a5b' }"></view>
        <view class="select-city-info" @click="handleToSelectCity">
          <view :class="[cityName ? 'city-name over-ellipsis' : 'no-city-name']">
            <text>{{ cityName || '城市中文名' }}</text>
          </view>
          <text class="tripwise_outline icon-arrowdn_outline a-fs-24 a-c-#14" v-if="!!cityName"></text>
        </view>
        <view class="line-item"></view>
        <view class="select-place-info">
          <input
            type="text"
            :placeholder="searchInputPlaceholder"
            v-model="searchVal"
            class="place-input"
            maxlength="1000"
            :disabled="!cityName"
            @input="handleInput"
            @click="clickInput"
            @focus="$emit('focus', true)"
          />
          <text class="icon ceekeefont guanbi close-icon" v-if="!!searchVal" @click="clearPlaceValue"></text>
        </view>
      </view>
    </view>
    <scroll-view class="select-place-content-wrapper" scroll-y="true">
      <view class="select-place-content">
        <!-- 常用 -->
        <view
          class="a-p-30-30-20-30 a-bg-#f a-br-12 a-mb-16"
          v-if="placeType !== 1 && pageFrom === 'page' && !searchVal && commolyUsedList.length > 0"
        >
          <view class="a-flex a-ai-c a-jc-sb">
            <view class="a-fs-28 a-lh-28 a-fw-500 a-c-#14">常去地点</view>
            <view
              class="a-flex a-ai-c a-c-#59 a-fs-24 a-h-24 a-lh-24"
              v-if="commolyUsedList.length > 6 && !showMoreCommonlyPlace"
              @click="showMoreCommonlyPlace = !showMoreCommonlyPlace"
            >
              展开更多
              <text class="tripwise_outline icon-arrowdn_outline a-fs-24 a-w-24 a-h-24 a-c-#59 a-ml-10"></text>
            </view>
          </view>
          <view class="a-pt-30 b-flex b-flex-warp a-w-100%">
            <carCommolyUsed
              :commolyUseds="showCommolyUsedList"
              @toSetCarPlace="toSetCarPlace"
              @toUseCar="initCommolyUsedData"
            ></carCommolyUsed>
          </view>
        </view>

        <view class="a-bg-#f a-br-12" v-if="searchVal ? searchList.length : historyPlaceList.length">
          <view class="a-p-30-30-20-30 a-flex a-ai-c a-jc-sb">
            <view class="a-fs-28 a-fw-500 a-c-#14">{{ searchVal ? '搜索结果' : '历史记录' }}</view>
            <view class="a-fs-24 a-c-#59" v-if="!searchVal" @click="clearHistoryRecord">
              <i class="tripwise_outline icon-delete_outline a-fs-24 a-h-24 a-lh-24rpx"></i>
              <text class="a-ml-4 a-h-24 a-lh-24rpx">清空</text>
            </view>
          </view>
          <view
            class="place-list"
            v-for="(item, index) in searchVal ? searchList : historyPlaceList"
            @click="savePlaceHistory(item, 'row')"
          >
            <i class="tripwise_outline icon-locate_outline a-c-#8c a-fs-32"></i>
            <view class="place-list-info">
              <view class="name-distance-info">
                <view class="name-info over-ellipsis a-h-28 a-lh-28" v-html="highLight(item.name)"></view>
              </view>
              <view class="place-details-info over-ellipsis a-h-24 a-lh-24">
                {{ item.address }}
              </view>
            </view>
            <view
              v-if="!item.hideCommonlyUsedBtn && pageFrom === 'page' && placeType === 2"
              class="a-w-94 a-h-38 a-br-20 a-bg-#057bff a-fs-22 a-lh-22 a-c-#fff a-flex a-jc-c a-ai-c a-ml-18"
              @click.stop="savePlaceHistory(item, 'used')"
            >
              <view class="tripwise_outline icon-tip_outline1 a-fs-22 a-c-#fff a-mr-4"></view>
              常用
            </view>
            <view
              v-if="pageFrom === 'popup'"
              class="a-w-80 a-h-48 a-br-6 a-ta-c a-lh-48 a-bg-#F85A5B a-c-#fff a-fs-20 a-fw-500 a-ml-18"
              @click.stop="savePlaceHistory(item, 'select')"
              >选择</view
            >
          </view>
        </view>

        <view class="a-flex a-jc-c a-ai-c a-h-100% a-bg-#f a-br-12" v-if="!searchVal && !historyPlaceList.length">
          <Empty msg1="暂无历史搜索" />
        </view>
        <view class="a-flex a-jc-c a-ai-c a-h-100% a-bg-#f a-br-12" v-if="searchVal && showNoResult">
          <Empty msg1="暂无结果" msg2="请您换个搜索词试试吧" src="https://image.ceekee.com/error/icon_nosearch.png" />
        </view>
      </view>
    </scroll-view>
    <green-area @confirm="confirmStartPoint" ref="greenAreaRef" :isShowFooterTips="false" :placeType="2"></green-area>
    <myloading></myloading>
  </view>
</template>

<script>
import { SearchGeocodeReGeo, POIPlaceText } from '@/api/car/car.js';
import greenArea from '@/pages/index2.0/components/indexCar/componets/greenArea.vue';
import Empty from '@/componentsV3/common/tw-empty/index.vue';
import { frequentlyUsedAdd } from '@/utils/bizcommon/frequentlyUsed.js';
import carCommolyUsed from '@/pages/product3.0/components/car/carCommolyUsed.vue';
import { productTypeConfig } from '@/common/config/productTypeConfig.js';
import { frequentlyUsedBusinessSearch } from '@/api/platform/tripwise-m.js';

export default {
  name: 'SelectPlace',
  components: {
    greenArea,
    Empty,
    carCommolyUsed,
  },
  props: {
    // page是作为一个页面 popup是作为弹出层
    pageFrom: {
      type: String,
      default: 'page',
    },
    activeCarItem: Object,
    selectType: {
      // 选择按钮作为设置常用功能还是编辑
      type: String,
      default: 'edit',
    },
    defaultCityData: {
      // 传进来的默认城市
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cityName: '',
      cityData: null,
      searchVal: '',
      requsetPositionApiCount: 0,
      POIPlaceTextApiGetTimes: 0, // 接口请求次数(目的是防止出现请求次数过快, 返回数据异常问题)
      searchList: [], // 搜索结果
      historyPlaceList: [], // 地点历史记录
      allCityList: [], // 城市列表
      placeType: 1, // 1-出发地 2-目的地
      searchDebounce: null,
      checkPostioning: false,
      source: '',
      showNoResult: false,
      placeItem: null,
      clickType: 'row',
      commolyUsedList: [],
      useTypeKey: 0,
      activeCarItemObj: null,
      showMoreCommonlyPlace: false,
    };
  },
  onLoad(options) {
    let { placeType = 1, source, useTypeKey } = options;
    this.source = source || '';
    this.placeType = Number(placeType);
    const startPlaceInfo = this.$store.state.indexCar.startPlaceInfo;
    this.cityName = startPlaceInfo?.CityName || '';
    this.cityData = {
      Id: startPlaceInfo?.CityId || startPlaceInfo?.CityCode || '',
    };
    this.useTypeKey = Number(useTypeKey || 0);
    this.getHistoryPlaceList();
    this.getCommolyUsed();
    uni.$on('setCityData', (res) => {
      this.searchVal = '';
      this.cityName = res.CityName || '';
      this.cityData = res || null;
      this.getCommolyUsed();
    });
  },
  onUnload() {
    uni.$off('setCityData');
  },
  created() {
    if (this.pageFrom === 'popup') {
      this.getHistoryPlaceList();
      if (this.defaultCityData && this.defaultCityData.cityId) {
        this.cityName = this.defaultCityData.cityName || '';
      } else {
        this.cityName = this.$store.state.indexCar.positionDetail?.CityName || '';
      }
      uni.$on('setCityDataFromPopup', (res) => {
        this.searchVal = '';
        this.cityName = res.CityName || '';
        this.cityData = res || null;
      });
    }
  },
  beforeUnmount() {
    uni.$off('setCityDataFromPopup');
  },
  computed: {
    IsGreenArea() {
      return this.$store.state.indexCar.locationInfo.IsGreenArea || false;
    },
    searchInputPlaceholder() {
      if (this.pageFrom === 'popup') {
        return '输入' + ((this.activeCarItem && this.activeCarItem.remark) || '自定义') + '的地址';
      }
      return this.placeType === 1 ? '您在哪儿上车' : '您在哪儿下车';
    },
    showCommolyUsedList() {
      return this.showMoreCommonlyPlace ? this.commolyUsedList : this.commolyUsedList.slice(0, 6);
    },
  },
  methods: {
    afterSetCommolyUsed() {
      this.$refs.selectPlaceRef.close();
      this.getCommolyUsed();
    },
    toSetCarPlace(item) {
      this.activeCarItemObj = item;
      this.$refs.selectPlaceRef.open();
    },
    initCommolyUsedData(data) {
      if (data) {
        let commoly = {
          Address: data.arrivalInfo,
          CityCode: data.arrivalCity,
          CityName: data.arrivalCityName,
          Regeocode: {
            Address: data.arrivalInfo,
            Location: data.lng + ',' + data.lat,
            Name: data.productName,
          },
        };

        this.$store.commit('setEndPlaceInfo', commoly || {});
        this.$store.commit('setEndPlaceCityInfo', commoly);
        uni.$emit('confirmSelectEndPlace');
        this.handleBack();
      }
    },
    //获取常用信息
    getCommolyUsed() {
      if (!(this.cityData && this.cityData.Id)) {
        return;
      }
      let params = {
        arrivalCity: this.cityData.Id,
        productType: productTypeConfig.car,
        useCarScene: this.useTypeKey < 0 ? 0 : this.useTypeKey,
      };
      this.$request({
        apiName: frequentlyUsedBusinessSearch,
        params,
      })
        .then((res) => {
          if (res.data) {
            this.commolyUsedList = res.data.frequentlyUsed || [];
          } else {
            this.commolyUsedList = [];
          }
        })
        .catch((e) => {
          if (e.Msg) {
            this.$app.Toast(e.Msg);
          }
        });
    },
    addIntoCommonlyUsed(item) {
      const params = {
        arrivalCity: item.cityCode,
        arrivalCityName: item.city,
        // arrivalCode: '',
        // arrivalDate: '',
        arrivalInfo: item.address,
        // departureCity: 0,
        // departureCityName: '',
        // departureCode: '',
        // departureDate: '',
        // departureInfo: '',
        extendInfo: '',
        lat: item.location.split(',')[1],
        lng: item.location.split(',')[0],
        // logoUrl: '',
        // mainKey: '',
        productCode: (this.activeCarItem && this.activeCarItem.productCode) || '',
        productName: item.name,
        productType: 7,
        remark: '',
        // requiredTime: '',
      };
      const msg = this.selectType === 'add' ? '设置成功' : '已设为常用';
      frequentlyUsedAdd(params, msg).then(() => {
        this.$set(this.placeItem, 'hideCommonlyUsedBtn', true);
        this.$emit('afterSetCommolyUsed');
        this.getCommolyUsed();
        // this.placeItem.hideCommonlyUsedBtn = true;
      });
    },
    clearHistoryRecord() {
      const settings = this.$app.GetSettings();
      settings.posiRecordListN = [];
      this.$app.SetSettings(settings);
      this.historyPlaceList = [];
    },
    handleBack() {
      uni.navigateBack();
    },
    handleToSelectCity() {
      uni.navigateTo({
        url: `/pages/index2.0/carIndex/selectCity?placeType=${this.placeType}&pageFrom=${this.pageFrom}`,
      });
    },
    handleInput(e) {
      clearTimeout(this.searchDebounce);
      if (e.detail.value) {
        this.searchDebounce = setTimeout(() => {
          this.getPlaceList();
        }, 500);
      }
    },
    highLight(text) {
      if (text) {
        const replaceReg = new RegExp(this.searchVal, 'i');
        const highLightStr = `<text style="color: #057BFF">${this.searchVal}</text>`;
        return text.replace(replaceReg, highLightStr);
      }
    },
    clearPlaceValue() {
      this.searchVal = '';
    },
    // 保存选择地点记录
    savePlaceHistory(item, clickType) {
      if (this.pageFrom === 'popup' && clickType === 'row') {
        return;
      }
      this.clickType = clickType;
      this.placeItem = item;
      if (this.selectType === 'add') {
        this.clickType = 'used';
      }

      let settings = this.$app.GetSettings();
      let { posiRecordListN = [] } = this.$app.GetSettings();
      if (posiRecordListN.length > 0) {
        // 最多保留8条历史记录
        if (posiRecordListN.length >= 8) {
          posiRecordListN.pop();
        }
        // 判断历史记录是否已存在该地点, 若存在则进行删除
        posiRecordListN.map((val, index) => {
          if (val.id && val.id === item.id) {
            posiRecordListN.splice(index, 1);
          }
        });
      }
      // 将当前元素添加至首位
      posiRecordListN.unshift(item);
      settings['posiRecordListN'] = posiRecordListN;
      this.$app.SetSettings(settings);
      if (this.clickType === 'used' || this.clickType === 'select') {
        this.getPositionInfo(item.location, '', item.name);
      }
      if (this.clickType === 'row') {
        if (this.placeType == 1) {
          /* 设置起始点 */
          this.$store.commit('setStartLocation', item.location ? item.location.split(',') : []);
          let location = item.location ? item.location.split(',') : [];
          let locationName = item.name;
          uni.$emit('confirmSelectPlace', {
            location,
            locationName,
          });
          uni.navigateBack();
        }
        if (this.placeType == 2) {
          /* 设置目的地 */
          this.$store.commit('setEndLocation', item.location ? item.location.split(',') : []);
          this.getPositionInfo(item.location, '', item.name);
        }
      }
    },
    // 获取位置信息(当前位置、推荐点列表等信息)
    getPositionInfo(location, type, name) {
      if (this.checkPostioning || !location) {
        return;
      }
      this.checkPostioning = true;
      this.requsetPositionApiCount += 1;
      this.$api({
        apiName: SearchGeocodeReGeo,
        params: {
          Coordtype: 'gcj02',
          CoordinateList: [
            {
              Lon: Array.isArray(location) ? location[0] : location.split(',')[0] || '',
              Lat: Array.isArray(location) ? location[1] : location.split(',')[1] || '',
            },
          ],
          GetTimes: this.requsetPositionApiCount,
          IsSearchRecommendPoint: 1,
          CarBoardType: 2, // 2-目的地
          IsProcessAdsorb: 1,
          RefId: 0,
          IsTravelBussiness: 1,
          ikey: '',
          MemberMac: '',
          PhoneType: '',
        },
      }).then((res) => {
        if (res.Code == '0000') {
          this.checkPostioning = false;
          if (res.Data) {
            if (type === 'greenArea') {
              // 绿区点击确认走这里
              if (this.clickType === 'row') {
                let cityInfo = {
                  CityName: res.Data.CityName,
                  CityCode: res.Data.CityCode,
                  CityId: res.Data.CityCode,
                };

                if (name) {
                  ((res.Data || {}).Regeocode || {}).Name = name;
                }
                /* 设置目的地 */
                this.$store.commit('setEndPlaceInfo', res.Data || {});
                this.$store.commit('setEndPlaceCityInfo', cityInfo);
                uni.$emit('confirmSelectEndPlace');
                this.handleBack();
                return;
              } else {
                // 设置常用走这里、选择修改地点走这里
                const params = {
                  cityCode: res.Data.CityCode,
                  city: res.Data.CityName,
                  // arrivalCode: '',
                  // arrivalDate: '',
                  address: res.Data.Address,
                  location: res.Data.Regeocode.Location,
                  name: res.Data.Regeocode.Name,
                  productType: 7,
                };
                if (this.clickType === 'used') {
                  this.addIntoCommonlyUsed(params);
                }
                if (this.clickType === 'select') {
                  uni.$emit('selectCommonlyPlace', params);
                }
                return;
              }
            }
            if (res.Data.IsGreenArea) {
              this.$store.commit('setLocationInfo', res.Data);
              this.$refs.greenAreaRef.openPopup();
            } else {
              if (this.clickType === 'select') {
                uni.$emit('selectCommonlyPlace', this.placeItem);
              }
              if (this.clickType === 'used') {
                // 不是绿区，且是添加常用
                this.addIntoCommonlyUsed(this.placeItem);
              }
              if (this.clickType === 'row') {
                let location = res.Data.Regeocode.Location ? res.Data.Regeocode.Location.split(',') : [];
                uni.$emit('confirmSelectPlace', {
                  location,
                  locationName: name,
                });
                this.handleBack();
              }
            }
          }
        } else {
          this.$app.Toast(res.Msg);
        }
      });
    },
    confirmStartPoint(val) {
      this.getPositionInfo(val, 'greenArea');
      this.$refs.greenAreaRef.handleClosed();
    },
    getPlaceList() {
      this.showNoResult = false;
      this.POIPlaceTextApiGetTimes += 1;
      this.searchList = [];
      this.$api({
        apiName: POIPlaceText,
        params: {
          keywords: [this.searchVal],
          city: this.cityName,
          types: '',
          offset: 20,
          page: 1,
          cityLimit: true,
          GetTimes: this.POIPlaceTextApiGetTimes,
        },
      }).then((res) => {
        if (res.Code === '0000') {
          if (res.Data && res.Data.Pois && res.Data.Pois.length > 0) {
            this.searchList = res.Data.Pois.filter((item) => item.location).map((item) => {
              return {
                name: item.Name,
                adname: item.Adname,
                address: item.Address,
                index: this.placeType, // 1- 起始地 2- 目的地
                location: item.location,
                id: item.Id,
                city: item.CityName,
                cityCode: item.CityCode,
                IsGreenArea: item.IsGreenArea,
              };
            });
            if (this.searchList.length > 0) {
              this.showNoResult = false;
            } else {
              this.showNoResult = true;
            }
          }
        } else {
          // uni.showToast({
          //   icon: 'none',
          //   title: res.Msg,
          //   mask: true,
          //   duration: 500,
          // });
          this.showNoResult = true;
        }
      });
    },
    clickInput() {
      if (!this.cityName) {
        this.$app.Toast('请选择城市!');
      }
    },
    // 获取历史上车点列表
    getHistoryPlaceList() {
      let { posiRecordListN = [] } = this.$app.GetSettings();
      this.historyPlaceList = [...posiRecordListN] || [];
    },
  },
};
</script>

<style lang="scss" scoped scoped>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;

  &.popup-container {
    height: 1000rpx;
  }
}

.select-place-header {
  display: flex;
  align-items: center;
  padding: 12rpx 20rpx;
  background-color: #ffffff;
  // box-shadow: 0 12rpx 16rpx 0 rgba(#000000, 0.04);
  position: relative;

  .back-item {
    margin-right: 25.25rpx;

    .back-icon {
      font-size: 24.75rpx;
    }
  }

  .select-city-place {
    flex: 1;
    border-radius: 32rpx;
    background-color: #f5f6fa;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 64rpx;
    padding: 0 30rpx;

    .circle-icon {
      width: 16rpx;
      height: 16rpx;
      border-radius: 50%;
      margin-right: 24rpx;
    }

    .select-city-info {
      height: 28rpx;
      font-size: 28rpx;
      color: #141414;
      display: flex;
      align-items: center;

      .city-name {
        margin-right: 12rpx;
        max-width: 79rpx;
      }

      .no-city-name {
        color: #bfbfbf;
      }

      .down-arrow {
        font-size: 15rpx;
      }
    }

    .line-item {
      padding: 0 16rpx;

      &::after {
        content: ' ';
        height: 24rpx;
        width: 1rpx;
        background-color: #bfbfbf;
        clear: both;
        display: block;
      }
    }

    .select-place-info {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      overflow: hidden;
      font-size: 28rpx;

      /deep/ .place-input {
        height: auto;
        line-height: unset;
        min-height: unset;
        flex: 1;
        margin-right: 20rpx;
        font-size: 28rpx;

        .uni-input-wrapper {
          font-size: 28rpx;
          color: #141414;

          .uni-input-placeholder {
            color: #bfbfbf;
            font-size: 28rpx;
          }
        }
      }

      .close-icon {
        font-size: 32rpx;
        color: #cbcbcb;
      }
    }
  }
}
.select-place-content-wrapper {
  height: calc(100% - 88rpx);
  :deep(.uni-scroll-view-content) {
    display: flex;
    flex-direction: column;
  }
}
.select-place-content {
  flex: 1;
  background-color: #ededed;
  padding: 20rpx;
  display: flex;
  flex-direction: column;

  .place-list {
    display: flex;
    align-items: center;
    padding: 30rpx;
    border-bottom: 1rpx solid #ededed;

    &:last-child {
      border: none;
    }

    .icon-shijian_line {
      color: #8c8c8c;
      font-size: 28.44rpx;
      margin-right: 19.78rpx;
    }

    .icon-icon_dingwei_common {
      font-size: 25.33rpx;
      margin-right: 21.11rpx;
      color: #8c8c8c;
    }

    .place-list-info {
      flex: 1;
      overflow: hidden;
      margin-left: 18rpx;

      .name-distance-info {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .name-info {
          flex: 1;
          font-size: 28rpx;
          font-weight: 500;
          color: #141414;
        }

        .distance-info {
          font-size: 24rpx;
          color: #8c8c8c;
        }
      }
    }

    .place-details-info {
      // width: 100%;
      font-size: 24rpx;
      color: #8c8c8c;
      margin-top: 16rpx;

      /deep/ .text-hight-light {
        color: #057bff;
      }
    }
  }
}
/deep/ .popup-content {
  padding: 0;
}
</style>
